document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".collection-product-form").forEach((form) => {
        const select = form.querySelector(".collection-variant-select");
        if (!select) return;
        const card = form.closest(".card-wrapper");
        const product = JSON.parse(
            card.querySelector(".collection-product-data").textContent
        );
        const variantInput = form.querySelector("[name=id]");
        const button = form.querySelector("[type=submit]");
        const buttonLabel = button.querySelector("span");
        select.addEventListener("change", function () {
            const variant = product.variants.find(v => v.id == this.value);
            if (!variant) return;
            variantInput.value = variant.id;
            updateButton();
            updatePrice();
            function updateButton(){
                if(variant.available){
                    button.disabled = false;
                    buttonLabel.textContent="Add to cart";
                }
                else{
                    button.disabled=true;
                    buttonLabel.textContent="Sold out";
                }
            }
            function updatePrice(){
                const wrapper=card.querySelector(".collection-card-price");
                if(!wrapper) return;
                wrapper.innerHTML=buildPriceHTML();
            }
            function buildPriceHTML(){
                let html='';
                if(
                    variant.compare_at_price &&
                    variant.compare_at_price>variant.price
                ){
                    html+=`
                    <div class="price price--on-sale">
                        <span class="price-item price-item--sale">
                            ${money(variant.price)}
                        </span>
                        <span class="price-item price-item--regular">
                            ${money(variant.compare_at_price)}
                        </span>
                    </div>
                    `;
                }
                else{
                    html+=`
                    <div class="price">
                        <span class="price-item">
                            ${money(variant.price)}
                        </span>
                    </div>
                    `;
                }
                return html;
            }
            function money(price){
                return (price/100).toLocaleString(
                    Shopify.locale || 'en-IN',
                    {
                        style:'currency',
                        currency:Shopify.currency.active
                    }
                );
            }
        });
    });
});